export const constructionDocumentsKey = 'construction-documents';
export const sharepointExportKey = 'sharepoint-export';
